import MarkerClusterer from '@googlemaps/markerclustererplus';



var mapObjects;
let map;
var clusterStyles = [
    {
        fontFamily: "Figtree, Arial",
        fontWeight: "bold",
        anchorText: [14, 1],
        width: 48,
        height: 48,
        url: ajax_object.template_directory + '/resources/assets/images/pin-blank.svg',
        textColor: '#373E42',
        textSize: 14,
    },
];

    let markers = [];
    let markerCluster;

$(window).on('resize', function () {
    if ($('#objects-map').length > 0) {
    }
});


if ($('#objects-map').length > 0) {
    markerCluster = new MarkerClusterer(mapObjects, markers, {
        styles: clusterStyles,
        gridSize: 40,
        averageCenter: true,
    });
}


function initMap() {
    const uluru = {lat: 54.752685334936544, lng: 25.26042997222399};

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: uluru,
        styles: [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#FFFFFF"
            }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
            },
                {
                    "weight": 2
            },
                {
                    "gamma": "1.00"
            },
                {
                    "color": "#FFFFFF"
            }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "weight": 0.6
            },
                {
                    "color": "#558EAE"
            }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#373E42"
            },
                {
                    "weight": "1.16"
            }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#373E42"
            },
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
            },
                {
                    "color": "#FF0000"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#FFFFFF"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#3F936F"
            },
                {
                    "saturation": "-10"
            },
                {
                    "lightness": "-28"
            },
                {
                    "weight": "2.08"
            },
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#3F936F"
            },
                {
                    "saturation": "-28"
            },
                {
                    "lightness": "7"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#4A9C93"
            },
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#4A5156"
            },
                {
                    "visibility": "off"
            },
                {
                    "lightness": "0"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#3F936F"
            },
                {
                    "lightness": "-3"
            },
                {
                    "visibility": "on"
            },
                {
                    "saturation": "-18"
            }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#406D80"
            },
                {
                    "visibility": "off"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#89D6FF"
            },
                {
                    "saturation": "-36"
            },
                {
                    "lightness": "1"
            }
            ]
        }
        ],
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
    });

    let image = {
        url: ajax_object['template_directory'] + '/public/images/marker.svg',
        size: new google.maps.Size(32, 32),
        scaledSize: new google.maps.Size(32, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 16)
    };

    let mainInfoWindow = new google.maps.InfoWindow({
        content: '<div class="info-window-wrap main-info"><div class="title">' + ajax_object['contacts_marker_info']['title'] + '</div><div class="address">' + ajax_object['contacts_marker_info']['address'] + '</div></div>',
        pixelOffset: new google.maps.Size(0, 0)
    });

    const marker = new google.maps.Marker({
        position: uluru,
        map: map,
        icon: image,
        infowindow: mainInfoWindow
    });

    google.maps.event.addListener(marker, 'mouseover', function (e) {
        this.infowindow.open(map, this);
    });

    google.maps.event.addListener(marker, 'mouseout', function (e) {
        this.infowindow.close(map, this);
    });
}

let body = $('body');

if (body.hasClass('page-template-template-contacts')) {
    initMap();
}